import CityIO from "../../Components/CityIO";
import { useSelector } from "react-redux";
import DeckGLMap from "./DeckglMap/index";
import LayerControls from "../../Components/LayerControls";
import LogosHeader from "../../Components/LogosHeader";
import LogosFooter from "../../Components/LogosFooter";

export default function CityScopeJS() {
  const dataIsDone = useSelector(
    (state) => state.dataState.dataIsDone
  );

  return (
    <>
      <CityIO />
      {dataIsDone && (
        <div  style={{ height: '100vh', width: '100vw', position: 'relative', overflow: 'hidden' }}>
          <DeckGLMap />
          <LogosHeader />
          <LayerControls />
          <LogosFooter />
        </div>
      )}
    </>
  );
}
